
$(function () { // wait for document ready
  // init

  var controller = new ScrollMagic.Controller();

  $('.bannerAnimation').each(function(){
    // define movement of panel
    var wipeAnimation = new TimelineMax() //videos
    .fromTo($(this).find(".progress__gutter"),  1, {css:{width: "0%"}}, {css:{width: "100%", ease: Power2.easeOut}}, "first")
    .fromTo($(this),  0.5, {scale: 0.89}, {scale:1, ease: Power2.easeOut}, "first")
    .fromTo($(this).find(".overlay"),  1, {opacity: 0}, {opacity:1, ease: Power1.out}, "first")
    .fromTo($(this).find(".container-video figure"), 1.2, {scale: 1}, {scale:1.2, ease: Power1.out}, "first")
    .fromTo($(this).find(".container-content .content-inner"), 0.2, {opacity: 0}, {opacity:1, ease: Power1.out}, "-=1")
    .fromTo($(this).find(".container-content .content-inner"), 1, {y: "100%"}, {y: "-20%", ease: Power1.out}, "-=1")
    .fromTo($(this).find("div.container-credits"), 1, {y: "40%"}, {y: "0%", ease: Power1.out}, "-=1")

    // create scene to pin and link animation
    var scene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: "onLeave",
      duration: "100%",
    })
    .setPin(this)
    .setTween(wipeAnimation)
    //.addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  });

  $('.animationBack').each(function(){
    // define movement of panels
    // create scene to pin and link animation
    var sceneanim = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: "onLeave"
    })
    .setClassToggle(this, "activade") // add class toggle
    .reverse(false)
    //.addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  });
});

$(function(){   
  $('.info-credits-btn').on('click', function(){
    $(this).parents('.container-credits').toggleClass('activo');
    $(this).parents('.banner-credits').find('.container-content').toggleClass('activo');
  });
});

var swiper = new Swiper('.sliders-container', {
  slidesPerView: 1,
  spaceBetween: 20,
  freeMode: true,
  touchRatio: 1,
  breakpoints: { 
    640: {
      slidesPerView: 2,
      spaceBetweenSlides: 30,
      touchRatio: 1
    },
    768: {
        slidesPerView: 3,
        touchRatio: 0,
    },
    1024: {
        slidesPerView: 4,
        touchRatio: 0,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var swiper = new Swiper('.sliderc-container', {
  slidesPerView: 1,
  spaceBetween: 20,
  freeMode: true,
  touchRatio: 1,
  breakpoints: { 
    640: {
      slidesPerView: 2,
      spaceBetweenSlides: 30,
      touchRatio: 1
    },
    768: {
      slidesPerView: 3,
      touchRatio: 0,
    },
    1024: {
      slidesPerView: 4,
      touchRatio: 0,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var swiper = new Swiper('.slidercdos-container', {
  slidesPerView: 1,
  spaceBetween: 20,
  freeMode: true,
  touchRatio: 1,
  breakpoints: { 
    640: {
      slidesPerView: 2,
      spaceBetweenSlides: 30,
      touchRatio: 1
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var swiperb = new Swiper('.sliderp-container', {
  slidesPerView: 1,
  spaceBetween: 20,
  preloadImages: false,
  lazy: true,
  freeMode: true,
  //noSwiping: true,
  //noSwipingClass: 'link-card',
  touchRatio: 1,
  breakpoints: { 
      640: {
          slidesPerView: 2,
          spaceBetweenSlides: 30,
          touchRatio: 1
      },
      768: {
          slidesPerView: 3,
          touchRatio: 0,
      },
      1024: {
          slidesPerView: 4,
          touchRatio: 0,
      },
  },
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});

var swiper = new Swiper('.slider-featured-container', {
  slidesPerView: 1,
  spaceBetween: 20,
  freeMode: true,
  touchRatio: 1,
  breakpoints: { 
      640: {
          slidesPerView: 2,
          spaceBetweenSlides: 30,
          touchRatio: 1
      },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});